<ng-container [formGroup]="stepForm">
  <mat-form-field appearance="outline" class="w-full" [hideRequiredMarker]="true">
    <mat-label>Numer telefonu</mat-label>
    <input
      [formControl]="phone"
      mask="000 000 000"
      class="w-full"
      matInput
      name="phone"
      (keydown.enter)="onSubmit()"
      prefix="+48 "
      inputmode="numeric"
    />
    <mat-error *ngIf="
            !!phone.errors?.minlength ||
            !!phone.errors?.maxlength ||
            !!phone.errors?.phoneNumberNotUnique  ">
      Podaj poprawny numer telefonu
    </mat-error>
    <mat-error *ngIf="!!phone.errors?.tooManyRequests">
      Przekroczono liczbę prób. Spróbuj ponownie za 1 minutę
    </mat-error>
  </mat-form-field>


  <div class="actions">
    <app-new-loader-button
      [disabled]="loading || (submitted && !stepForm.valid)"
      (buttonClick)="onSubmit()"
      [loading]="loading"
      class="auth-button"
      id="register-button"
      [customType]="LoaderButtonType.RAISED"
      color="accent">
      Dalej
    </app-new-loader-button>
  </div>
</ng-container>
